import { render } from "./products.vue.js?vue&type=template&id=6874d414!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./products.vue?vue&type=template&id=6874d414"
import script from "./products.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./products.vue?vue&type=script&lang=js"
export * from "./products.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./products.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__